const maintenance = {
  clientPortalMainMessage: 'Désolé, le portail client est présentement fermé pour cause de maintenance',
  clientPortalSecondaryMessage: 'Veuillez réessayer plus tard',
  workerPortalMainMessage: 'Désolé, le portail des travailleurs est présentement fermé pour cause de maintenance',
  workerPortalSecondaryMessage: 'Veuillez réessayer plus tard',
  refresh: 'Rafraichir',
};

export default maintenance;
